import { getOr } from 'lodash/fp';

const getOrNull = getOr(null);
// @ts-expect-error - Automatic, Please fix when editing this file
const selectCurrentDrawer: (state: object) => string | null = getOrNull('drawer.openDrawerId');

export default selectCurrentDrawer;
